import { AddGuestBody } from '../add-holder-modal.type';

const trimedCountry = (countryName: string) => {
  // TODO: Handle countries by slug https://xceeddev.atlassian.net/browse/XCEED-5273
  const cutFromIdx: number = countryName.lastIndexOf('(');
  return cutFromIdx === -1 ? countryName : countryName.substring(0, cutFromIdx - 1);
};

const formattedDate = (date: string) => {
  return date.split('/').reverse().join('-');
};

const formatFieldValue = (key: string, value: string): string => {
  switch (key) {
    case 'phone':
      return value.replaceAll(' ', '');
    case 'country':
      return trimedCountry(value);
    case 'birth':
      return formattedDate(value);
    default:
      return value;
  }
};

const formatFormFields = (data: { [x: string]: string }) => {
  return Object.entries(data).map(([key, value]) => ({
    name: key,
    value: formatFieldValue(key, value),
  }));
};

export const mapDataToBackend = (data: Record<string, string>, passId: string): AddGuestBody => {
  const { channelId, firstName, lastName, email, ...rest } = data;
  return {
    offerId: passId,
    channelId,
    bookingFormFields: formatFormFields({ firstName, lastName, email }),
    ticketHolderFormFields: [formatFormFields({ firstName, lastName, email, ...rest })],
    numTickets: 1,
  };
};
